import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/chevron down small.svg` */
export const ChevronDownSmallIcon = createTripletGlyphIcon('ChevronDownSmallIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.59771 5.83987C3.40618 5.60446 3.44163 5.25826 3.67681 5.06643C3.91229 4.87456 4.25935 4.91005 4.45122 5.14553L8.13091 9.66311L11.5372 5.16116C11.7204 4.91896 12.0654 4.87056 12.3077 5.05374C12.5499 5.237 12.5973 5.58201 12.4141 5.82424L8.64165 10.8106C8.39825 11.1323 7.91796 11.1409 7.66314 10.8281L3.59771 5.83987Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.85292 5.90693C2.60923 5.6073 2.65414 5.16666 2.95351 4.92256C3.25316 4.67861 3.69469 4.72365 3.93886 5.02314L9.18691 11.4655L14.0463 5.04268C14.2795 4.73468 14.7186 4.67393 15.0268 4.90693C15.335 5.14013 15.3955 5.57912 15.1625 5.8874L9.84413 12.9167C9.53047 13.3312 8.91175 13.3421 8.58339 12.9392L2.85292 5.90693Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.87282 7.85601C3.55894 7.4708 3.61673 6.90344 4.00172 6.5894C4.38694 6.27558 4.95333 6.33332 5.26735 6.71831L8.78004 11.0298L12.2927 15.3414L18.7976 6.7437C19.0976 6.34765 19.6621 6.26918 20.0584 6.5689C20.4546 6.86869 20.5327 7.43328 20.2332 7.82964L13.1414 17.2027C12.7361 17.7377 11.9365 17.7523 11.5125 17.232L3.87282 7.85601Z"
        fill="currentColor"
      />
    </svg>
  ),
});
